import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import StepsViewModal from "./StepsViewModal";

export default function StepsModalButton({
  buttonText = "View All Attack Steps",
  sx = {},
  steps = [],
  filteredScenariosSets = [],
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { trackEvent } = useAPI();

  const handleClick = () => {
    trackEvent("User clicked to open Steps modal");
    setIsModalOpen(true);
  };

  return (
    <>
      <Box
        display="flex"
        gap={1}
        alignItems="center"
        sx={{
          cursor: "pointer",
          ...sx,
        }}
        onClick={handleClick}
      >
        <Typography variant="caption">{buttonText}</Typography>
        <LaunchRoundedIcon sx={{ width: "18px" }} />
      </Box>

      <StepsViewModal
        open={isModalOpen}
        onClose={() => {
          trackEvent("User clicked to close Steps modal");
          setIsModalOpen(false);
        }}
        steps={steps}
        filteredScenariosSets={filteredScenariosSets}
      />
    </>
  );
}
